<template>
  <div class="l-number-container" :class="myclass">
    <div class="l-number"> {{ current }}/{{ total }} </div>
  </div>
</template>

<script>
export default {
  name: 'l-number',
  props: {
    current: {
      type: Number
    },
    total: {
      type: Number
    },
    myclass: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
